const svgIcons = require("../../../../config/inlinesvg.json");

/**
 * Update content when cart is empty
 * @param {String} emptyMsg - Empty cart resource message
 */
function updateCartContent(emptyMsg) {
    $(".cart-content").remove();
    $(".cart").addClass("cart-empty");
    $(".cart .cart-listing-header-inner").empty().append("<p class='text-center cart-empty-text'>" + emptyMsg + "</p> ");
    $(".cart .col-12").removeClass("col-lg-8");
}

/**
* Updates the line item price and original price if applicable
* @param {object} $lineItemWrapper - The jQuery object representing the line item wrapper
* @param {string} priceClass - The class selector for the price element
* @param {string} priceValue - The updated price value
* @param {string} originalPriceValue - The original price value, if applicable
* @returns {void}
*/
function updateLineItemPrice($lineItemWrapper, priceClass, priceValue, originalPriceValue) {
    let $price = $lineItemWrapper.find(priceClass);
    let $originalPrice = $lineItemWrapper.find(".cart-original-price");

    $price.text(priceValue);

    if (originalPriceValue) {
        if ($originalPrice.length) {
            $originalPrice.text(originalPriceValue);
        } else {
            $lineItemWrapper.append(`<span class='cart-original-price'>${originalPriceValue}</span>`);
            $price.addClass("gold-price");
        }
    } else if (originalPriceValue === null) {
        $price.removeClass("gold-price");
        $originalPrice.remove();
    }
}

module.exports = {
    /**
     * Clears coupon error messages and removes is-invalid class
     * @param {void}
     */
    clearCouponError: function() {
        $(".coupon-missing-error").hide();
        $(".coupon-error-message").empty();
        $(".promo-code-form").find(".form-control").removeClass("is-invalid");
    },

    /**
     * re-renders the order totals and the number of items in the cart
     * @param {Object} data - AJAX response from the server
     */
    updateCartTotals: function(data) {
        var $minicartQtyResource = $(".minicart-quantity").attr("data-resource");
        var $minicartQty = data.numItems < 100 ? data.numItems : $minicartQtyResource;
        $(".cart-items-number").empty().append(data.resources.numberOfItems);
        $(".shipping-cost").empty().append(data.totals.totalShippingCost);
        $(".tax-total").empty().append(data.totals.totalTax);
        $(".grand-total").empty().append(data.totals.grandTotal);
        $(".sub-total").empty().append(data.totals.subTotalAdjustedFormatted);
        $(".cart-totals-container .sub-total").empty().append(data.totals.subTotal);
        $(".minicart-quantity").empty().append($minicartQty);
        $(".minicart-title span").empty().append(`(${data.resources.numberOfItems})`);
        $(".minicart-link").attr({
            "data-minicart-items": $minicartQty
        });
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $(".order-discount").removeClass("hide-order-discount");
            $(".order-discount-total").empty()
                .append("- " + data.totals.orderLevelDiscountTotal.formatted);
        } else {
            $(".order-discount").addClass("hide-order-discount");
        }

        if (data.totals.shippingLevelDiscountTotal.value > 0) {
            $(".shipping-discount").removeClass("hide-shipping-discount");
            $(".shipping-discount-total").empty().append("- " +
                data.totals.shippingLevelDiscountTotal.formatted);
        } else {
            $(".shipping-discount").addClass("hide-shipping-discount");
        }

        data.items.forEach(function (item) {
            if (data.totals.orderLevelDiscountTotal.value > 0) {
                $(".coupons-and-promos").empty().append(data.totals.discountsHtml);
            }
            if (item.renderedPromotions) {
                $(".item-" + item.UUID).empty().append(item.renderedPromotions);
            } else {
                $(".item-" + item.UUID).empty();
            }

            if (item.available) {
                var $lineItemWrapper = $(".uuid-" + item.UUID + " .unit-price .line-item-wrapper");
                updateLineItemPrice($lineItemWrapper, ".price", item.priceTotal.price, data?.originalQuantityPrice?.[item.UUID]);
                $(".line-item-price-" + item.UUID + " .unit-price").empty().append(item.priceTotal.renderedPrice);
                $(".item-total-" + item.UUID).empty().append(item.priceTotal.renderedPrice);
            }
        });
    },

    /**
     * appends params to a url
     * @param {string} url - Original url
     * @param {Object} params - Parameters to append
     * @returns {string} result url with appended parameters
     */
    appendToUrl: function (url, params) {
        var newUrl = url;
        newUrl += (newUrl.indexOf("?") !== -1 ? "&" : "?") + Object.keys(params).map(function (key) {
            return key + "=" + encodeURIComponent(params[key]);
        }).join("&");

        return newUrl;
    },

    /**
     * Checks whether the basket is valid. if invalid displays error message and disables
     * checkout button
     * @param {Object} data - AJAX response from the server
     */
    validateBasket: function (data) {
        const $cartError = $(".cart-error");
        var $minicartQtyResource = $(".minicart-quantity").attr("data-resource");
        var $minicartQty = data.numItems < 100 ? data.numItems : $minicartQtyResource;

        if (data.valid.error) {
            if (data.valid.message) {
                const errorHtml = `<div class="valid-cart-error pb-3 px-lg-5" role="alert">${data.valid.message}</div>`;

                $cartError.html(errorHtml);
            } else {
                updateCartContent(data.resources.emptyCartMsg);
                $(".number-of-items").empty().append(data.resources.numberOfItems);
                $(".minicart-quantity").empty().append($minicartQty);
                $(".minicart-link").attr({
                    "data-minicart-items": $minicartQty
                });
                $(".minicart-popover").empty().removeClass("show");
            }

            $(".checkout-btn").addClass("disabled");
        } else {
            $cartError.empty();
            $(".checkout-btn").removeClass("disabled");
        }
    },

    /**
     * re-renders the order totals and the number of items in the cart
     * @param {Object} message - Error message to display
     */
    createErrorNotification: function (message) {
        var errorHtml = "<div class='alert alert-danger alert-dismissible valid-cart-error fade show' role='alert'>" +
            "<button type='button' class='close' data-dismiss='alert' aria-label='Close'>" +
            "<span aria-hidden='true'>&times;</span>" +
            "</button>" + message + "</div>";

        $(".cart-error").append(errorHtml);
    },

    /**
     * re-renders the approaching discount messages
     * @param {Object} approachingDiscounts - updated approaching discounts for the cart
     */
    updateApproachingDiscounts: function (approachingDiscounts) {
        const $approachingDiscounts = $(".approaching-discounts");
        let html = "";

        $approachingDiscounts.empty();
        if (approachingDiscounts.length > 0) {
            approachingDiscounts.forEach(function (item) {
                html += `<div class="cart-promo-truck-icon d-flex align-items-center justify-content-center">
                    <span class="mr-3">${svgIcons.truck}</span>
                    <span>${item.discountMsg}</span></div>`;
            });
        }
        $approachingDiscounts.append(html);
    },

    /**
    * Removes missing products from the mini cart
    * @param {object} basketItems - array of basket items
    */
    removeMissingProductsFromMiniCart: function (basketItems) {
        const $miniCart = $(".minicart-popover.show");
        const $miniCartItems = $miniCart.find(".card[class*='uuid-']");

        if ($miniCart.length && basketItems.length !== $miniCartItems.length) {
            const uuids = basketItems.map(function (item) {
                return item.UUID;
            });

            $.each($miniCartItems, function (index, item) {
                const $item = $(item);
                const itemClass = $item.attr("class");
                const hasUUIDClass = uuids.some(function (uuid) {
                    return itemClass.includes(uuid);
                });

                if (!hasUUIDClass) {
                    $item.remove();
                }
            });
        }
    },

    /*
    * Shows error message in mini cart
    * @param {jQuery} $minicartPopover - mini cart popover
    * @param {string} message - error message
    */
    showMiniCartError: function ($minicartPopover, message) {
        //Shows an error message in the mini cart popover
        var $minicartPopoverMessage = $minicartPopover.find(".valid-cart-error");

        if ($minicartPopoverMessage.length === 0) {
            $minicartPopover.find(".minicart-error.cart-error")
                .html(`<div class="valid-cart-error pb-2" role="alert">${message}</div>`);
        } else {
            $minicartPopoverMessage.html(message);
        }
    },

    updateCartContent: updateCartContent,
    updateLineItemPrice: updateLineItemPrice
};
